<div class="section-title">Fleetwide operations</div>
<div>
	<div class="bubble-tabs mt-0">
		<a class="bubble-tab" routerLink="asset-logins" routerLinkActive="selected">Asset Logins</a>
		<a class="bubble-tab" routerLink="user-logins" routerLinkActive="selected">User Logins</a>
		<a class="bubble-tab" routerLink="firmware" routerLinkActive="selected">Firmware</a>
		<a class="bubble-tab" routerLink="sent-emails" routerLinkActive="selected">Sent Emails</a>
	</div>
	<router-outlet (activate)="updateRouterOutlet($event)"></router-outlet>
</div>